import React from 'react';
import { string, shape, arrayOf } from 'prop-types';
import Field from 'components/Form/Field/Field';
import FormSelector from 'components/Form/Selector/Selector';
import SearchInput from 'components/Form/SearchInput/SearchInput';
import FormCheckbox from 'components/Form/Checkbox/Checkbox';
import './Filters.scss';

const cbn = 'audit-log-popup-filters';

function AuditLogPopupFilters({ availableActions }) {
  return (
    <div className={cbn}>
      <div className={`${cbn}__item`}>
        <Field
          component={FormSelector}
          name="action"
          options={availableActions}
          isSearchable={false}
          idsOnly
        />
      </div>
      <div className={`${cbn}__item__search`}>
        <Field component={SearchInput} name="search" />
      </div>
      <div className={`${cbn}__item__exclude-bots`}>
        <Field component={FormCheckbox} name="excludeBots" label="excludeBots">
          Exclude Bots
        </Field>
      </div>
    </div>
  );
}

AuditLogPopupFilters.propTypes = {
  availableActions: arrayOf(
    shape({
      key: string,
      label: string,
    }),
  ),
};

AuditLogPopupFilters.defaultProps = {
  availableActions: null,
};

export default AuditLogPopupFilters;
